import { render } from "./InventoryItem.vue?vue&type=template&id=54de014a"
import script from "./InventoryItem.vue?vue&type=script&lang=js"
export * from "./InventoryItem.vue?vue&type=script&lang=js"

import "./InventoryItem.vue?vue&type=style&index=0&id=54de014a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__